
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Da wir auf einem Planeten leben, der im 24-Stunden-Takt der Sonne mal die eine, mal die andere Seite zudreht, hat der Mensch eine innere Uhr entwickelt, die diesem Zeitrahmen folgt. `}<M mdxType="M">{`Dieser Rhythmus von ungefähr 24 Stunden ist so stabil, dass ihn selbst Menschen beibehalten, die vollkommen von der Aussenwelt abgeschnitten sind, wie Versuche in Höhlen in Italien und bei Andechs in Oberbayern gezeigt haben.`}</M>{` In dieser Taktung ist nicht vorgesehen, dass Erdbewohner sich rasend schnell über den Planeten bewegen. Während der Flieger in eine andere Zeitzone düst, bleibt der Rhythmus des Körpers buchstäblich auf der Strecke – und wir leiden an einem Jetlag. `}</p>
    <Image file='images/viz_innerclock.svg' title='Die innere Uhr des Menschen' source='TA-Grafik mrue/Quelle: Nobelpreiskomitee' style={{
      maxWidth: '120% !important',
      width: '120% !important'
    }} mdxType="Image" />
    <p>{`Doch wo «befindet» sich dieser Taktgeber genau? Unsere innere Uhr sitzt nicht nur im Kopf, sondern in jeder einzelnen Körperzelle. Dirigiert wird sie von einer Art Zentraluhr im Gehirn, die sich im sogenannten suprachiasmatischen Kern befindet. Dieser liegt etwa zwei Fingerbreit hinter der Nasenwurzel, dort, wo sich die Sehnerven kreuzen. In einem ungefähren 24-Stunden-Rhythmus steuert die innere Uhr unter anderem Körpertemperatur, Hormonausschüttungen, Hungergefühl und Schmerzempfinden. Sie bestimmt, wann die beste Zeit zum Schlafen, Aufstehen, Lernen, Essen oder Sporttreiben ist und zu welchem Zeitpunkt wir unsere Medikamente einnehmen sollten. Pauschalempfehlungen machen dabei aber nur begrenzt Sinn, denn die innere Uhr wird wie die Körpergrösse oder die Augenfarbe von Genen bestimmt. Sie kann in verschiedenen Menschen sehr unterschiedlich ticken. Chronobiologen sprechen von «Lerchen», die selbst an freien Tagen früh aufstehen und früh ins Bett gehen, und von «Eulen», für die das Gegenteil gilt. Das Ganze ist aber ein Kontinuum, das sich zwischen diesen zwei Extremen bewegt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;